<template>
	<video
		id="player-container-id"
		width="414"
		height="200"
		preload="auto"
		playsinline
		webkit-playsinline
	></video>
</template>

<script>
import TCPlayer from 'tcplayer';
import 'tcplayer.js/dist/tcplayer.min.css';

export default {
	props: {
		videoSrc: {
			type: String,
			default: ''
		},
		poster: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			player: null
		};
	},
	watch: {
		videoSrc(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.player.src(newVal);
				this.player.poster(this.poster);
			}
		}
	},
	mounted() {
		this.player = TCPlayer('player-container-id', {
			sources: [
				{
					src: this.videoSrc,
					type: 'video/mp4' // 添加明确的视频类型声明
				}
			],
			poster: this.poster,
			reportable: false
		});
	},
	beforeDestroy() {
		this.player.dispose();
	},
	methods: {
		play() {
			this.player.play();
		},
		pause() {
			this.player.pause();
		}
	}
};
</script>

<style>
.vjs-poster {
	background-size: cover;
}

.vjs-control-bar {
	height: 3em !important;
	font-size: 25px !important;
}
</style>
